module.exports = __webpack_public_path__ + "static/img-download-brochures-95bed9def1acfdeaee2dc05ce529b4b8.png";